import type { IconProps } from '../types/IconProps.ts';
export const Percent: IconProps = {
    name: 'Percent',
    children: [
        `<path d="M5 19 19 5" />`,
        `<circle cx="7" cy="7" r="2" />`,
        `<circle cx="17" cy="17" r="2" />`,
    ]
};